export default "__VITE_ASSET__c6617b94__"